import React, { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Button, Card, CardMedia, Typography } from "@mui/material";
import ExtrasIncrementer from "../Components/IncrementDecrementBtn/ExtrasIncrementer";
import dayjs from "dayjs";
import "./reservation.css";
import opelAstra from "../Assets/img_car/detail/18.opel_astra.png";
import peugeot308 from "../Assets/img_car/detail/peugeot308.png";
import peugeot3008 from "../Assets/img_car/detail/peugeot3008.png";
import { vehicleCodeChanger } from "../helpers/vehicleCodeChanger";
import miniCooperOne from "../Assets/img_car/detail/miniOneAutomatic.webp";
import opelInsigniaStation from "../Assets/img_car/detail/opel_insignia_station.png";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1C2541",
    },
    secondary: {
      main: "#38AECC",
    },
    danger: "#fa0505",
  },
});

function Optionals({
  extraFees,
  vehicleChoosedDetails,
  reservationInfo,
  setWasOptionalsChoosed,
  setVehicleExtras,
  setTotalRentalValue,
  totalRentalValue,
  pickUpDesk,
  dropOffDesk,
  totalDays,
}) {
  const { t } = useTranslation();
  const [insuranceValue, setInsuranceValue] = useState(0);

  const handleReservationClientDetails = () => {
    setWasOptionalsChoosed(true);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const insuranceValuePerDay =
      vehicleChoosedDetails.vehicleCode === "CDAV" ||
      vehicleChoosedDetails.vehicleCode === "CDAD" ||
      vehicleChoosedDetails.vehicleCode === "CGAD"
        ? 30
        : (parseFloat(vehicleChoosedDetails.SCDW) +
            parseFloat(vehicleChoosedDetails.GTW)) /
          (vehicleChoosedDetails.updatedTotalDays === 0
            ? totalDays
            : vehicleChoosedDetails.updatedTotalDays);
    setInsuranceValue(insuranceValuePerDay);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div className="container">
        <div className="left-side">
          <ExtrasIncrementer
            insuranceValue={insuranceValue}
            extras={extraFees}
            setExtras={setVehicleExtras}
            totalDays={
              vehicleChoosedDetails.updatedTotalDays === 0
                ? totalDays
                : vehicleChoosedDetails.updatedTotalDays
            }
            vehicleGroup={vehicleChoosedDetails.vehicleCode}
            pickUpDesk={pickUpDesk}
            dropOffDesk={dropOffDesk}
          />
        </div>
        <div className="car-details">
          <Card>
            <Typography
              gutterBottom
              sx={{ backgroundColor: "primary.main" }}
              variant="h5"
              align="center"
              color="white"
              component="div"
            >
              {t("myCar")}
            </Typography>
            <Typography
              gutterBottom
              variant="h5"
              align="center"
              color="primary.main"
              component="div"
            >
              {t("group")}{" "}
              {vehicleCodeChanger(vehicleChoosedDetails.vehicleCode)}
            </Typography>
            <Typography
              gutterBottom
              variant="h6"
              align="center"
              component="div"
            >
              {vehicleChoosedDetails.vehicleCode === "CWMD"
                ? "Opel Insignia Station"
                : vehicleChoosedDetails.vehicleCode === "HXMD"
                  ? "Peugeot 208 GPS"
                  : vehicleChoosedDetails.vehicleModel}{" "}
              {t("orSimilar")}
            </Typography>
            <CardMedia
              sx={{ margin: "20px", height: 180, width: 300 }}
              image={
                vehicleChoosedDetails.vehicleCode === "TXT"
                  ? peugeot308
                  : vehicleChoosedDetails.vehicleCode === "CDAV"
                    ? opelAstra
                    : vehicleChoosedDetails.vehicleCode === "CDAD"
                      ? peugeot308
                      : vehicleChoosedDetails.vehicleCode === "CGAD"
                        ? peugeot3008
                        : vehicleChoosedDetails.vehicleCode === "CTAV"
                          ? miniCooperOne
                          : vehicleChoosedDetails.vehicleCode === "CWMD" // Agora esta condição será testada antes da URL genérica
                            ? opelInsigniaStation
                            : vehicleChoosedDetails.pictureUrl // Esta verificação genérica deve ficar por último ou quase no fim
                              ? process.env.PUBLIC_URL +
                                "/img_car/detail/" +
                                vehicleChoosedDetails.pictureUrl
                              : null
              }
              title="CAR"
            />
            <Typography
              sx={{ backgroundColor: "primary.main" }}
              gutterBottom
              variant="h5"
              align="center"
              color="white"
              component="div"
            >
              {t("myReservation")}
            </Typography>
            <>
              <Typography
                gutterBottom
                variant="h6"
                align="center"
                component="div"
              >
                {t("pickUp")}
              </Typography>
              <Typography
                gutterBottom
                variant="body1"
                align="center"
                component="div"
              >
                {pickUpDesk === 41
                  ? "Funchal- Rua Ivens Nº12"
                  : pickUpDesk === 42
                    ? "Aeroporto da Madeira"
                    : pickUpDesk === 47
                      ? "Calheta"
                      : pickUpDesk === 46
                        ? "Norte"
                        : "Unknown Location"}
              </Typography>
              <Typography
                gutterBottom
                variant="body1"
                align="center"
                component="div"
              >
                {dayjs(reservationInfo?.date_pickup).format("DD/MM/YYYY")}{" "}
                {t("at")} {reservationInfo?.time_pickup}
              </Typography>
              <Typography
                gutterBottom
                variant="h6"
                align="center"
                component="div"
              >
                {t("dropOff")}
              </Typography>
              <Typography
                gutterBottom
                variant="body1"
                align="center"
                component="div"
              >
                {dropOffDesk === 41
                  ? "Funchal- Rua Ivens Nº12"
                  : dropOffDesk === 42
                    ? "Aeroporto da Madeira"
                    : dropOffDesk === 47
                      ? "Calheta"
                      : dropOffDesk === 46
                        ? "Norte"
                        : "Unknown Location"}
              </Typography>
              <Typography
                gutterBottom
                variant="body1"
                align="center"
                component="div"
              >
                {dayjs(reservationInfo?.date_return).format("DD/MM/YYYY")}{" "}
                {t("at")} {reservationInfo?.time_return}
              </Typography>
              <Typography
                gutterBottom
                variant="h6"
                align="center"
                component="div"
              >
                {t("carPerDayValue")}
              </Typography>
              <Typography
                gutterBottom
                variant="body1"
                align="center"
                component="div"
              >
                {(
                  Math.round(vehicleChoosedDetails.totalPrice * 100) / 100
                ).toFixed(2)}
                € {t("per")}{" "}
                {vehicleChoosedDetails.updatedTotalDays === 0
                  ? totalDays
                  : vehicleChoosedDetails.updatedTotalDays}{" "}
                {t("days")}
              </Typography>
              <Typography
                sx={{ backgroundColor: "primary.main" }}
                gutterBottom
                variant="h5"
                align="center"
                color="white"
                component="div"
              >
                {t("extrasChoosed")}
              </Typography>
              <TableContainer>
                <Table sx={{ minWidth: 200 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("extra")}</TableCell>
                      <TableCell align="right">{t("cost")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {extraFees?.map(
                      ({ index, extraName, quantity, totalValue }) =>
                        quantity > 0 && (
                          <TableRow
                            key={index} // Ensure unique key
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {extraName === "additionalDriver"
                                ? t("additionalDriverPromotion")
                                : t(extraName) + " X" + quantity}
                            </TableCell>
                            <TableCell align="right">
                              {" "}
                              {extraName === "additionalDriver" &&
                              quantity === 0
                                ? 0
                                : totalValue.toFixed(2) + "€"}
                            </TableCell>
                          </TableRow>
                        ),
                    )}
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {t("totalPrice")}
                      </TableCell>
                      <TableCell align="right">
                        {totalRentalValue.toFixed(2)}€
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <Button
                sx={{ marginBottom: 2 }}
                onClick={() => handleReservationClientDetails()}
                variant="contained"
                size="large"
              >
                {t("continue")}
              </Button>
            </>
          </Card>
        </div>
      </div>
    </ThemeProvider>
  );
}

Optionals.propTypes = {
  extraFees: PropTypes.object,
  setExtraFees: PropTypes.object,
  vehicleChoosedDetails: PropTypes.object,
  reservationInfo: PropTypes.any,
  setWasOptionalsChoosed: PropTypes.any,
  setVehicleExtras: PropTypes.any,
  setTotalRentalValue: PropTypes.any,
  totalRentalValue: PropTypes.any,
  pickUpDesk: PropTypes.number,
  dropOffDesk: PropTypes.number,
  totalDays: PropTypes.number,
};

export default Optionals;
